import { formatValorPlan } from "src/utils/formatNumber";
import {
  LABEL_ESTADO,
  LABEL_RECONCILIACION,
  estaDetenido,
} from "src/components/facturacion/estadoFacturacion";

const MONEDAS_PESO = ["PESOS", "PESO", "CLP"];
const esMonedaNominal = (m) =>
  m && !MONEDAS_PESO.includes(String(m).toUpperCase());

// Exporta los items YA filtrados (lo que se ve). Cero dependencia nueva: xlsx ya esta en package.json.
export async function exportarFacturacionExcel(items, nombreArchivo) {
  const XLSX = await import("xlsx");
  const filas = items.map((i) => [
    i.rutCliente,
    i.nombreCliente,
    i.nombrePlan,
    i.tipoFrecuencia === "MES" ? "Mensual" : "Anual",
    LABEL_ESTADO[i.estado] ?? i.estado,
    // El backend presenta al detenido con estado ERROR, asi que en la columna Estado no se
    // distingue de un error reintentable. Esta planilla es con la que se persigue el caso
    // fuera de la pantalla, donde ya no hay nada que lo explique: va la marca cuando el item
    // esta detenido, y vacio cuando no, para no rotular filas que nadie tiene que revisar.
    estaDetenido(i)
      ? (LABEL_RECONCILIACION[i.estadoReconciliacion] ?? i.estadoReconciliacion)
      : "",
    i.folio || "",
    i.cantidad ?? 1,
    // Valor en CLP (numero crudo, para que Excel lo trate como numero).
    Number(i.valorTotal ?? 0),
    // Valor nominal en la moneda del plan, solo si no es pesos (texto: "UF 12,3").
    esMonedaNominal(i.tipoMoneda)
      ? formatValorPlan((i.valorDesc ?? 0) * (i.cantidad ?? 1), i.tipoMoneda)
      : "",
    // Descuento solo si esta activo (vigente); vencido o sin descuento -> vacio.
    i.descuentoActivo ? `${i.descuento}%` : "",
  ]);
  const ws = XLSX.utils.aoa_to_sheet([
    [
      "RUT",
      "Cliente",
      "Plan",
      "Tipo",
      "Estado",
      "Reconciliación",
      "Folio",
      "Cantidad",
      "Valor (CLP)",
      "Valor nominal",
      "Descuento",
    ],
    ...filas,
  ]);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Facturación");
  XLSX.writeFile(wb, `${nombreArchivo}.xlsx`);
}
